import { EditableClientProps } from '@/shared/types/editable';

export const createIconButton = (params: {
  url?: string;
  newWindow?: boolean;
  onClick?: () => void;
  className: string;
  tooltipText?: string;
  label?: string;
}) => {
  const { url, newWindow, onClick, className, tooltipText, label } = params;

  const a = document.createElement('a');

  a.href = url ?? '#';

  if (newWindow) {
    a.target = '_blank';
  }

  if (onClick) {
    a.addEventListener('click', (event) => {
      event.preventDefault();
      onClick();
    });
  }

  if (tooltipText) {
    a.title = tooltipText;
    a.setAttribute('data-bs-toggle', 'tooltip');
    a.setAttribute('data-bs-placement', 'right');
  }

  const i = document.createElement('i');

  i.className = className;

  a.appendChild(i);

  if (label) {
    const labelSpan = document.createElement('span');
    labelSpan.textContent = label;
    labelSpan.className = 'ms-1';
    a.appendChild(labelSpan);
  }

  return a;
};

export const initFormIconButtons = (p: EditableClientProps, e: HTMLElement) => {
  if (!p.obscured && !p.copyable) return;
  if (p.modelId && p.editMode !== 'Form') return;

  const input = e.querySelector('input') as HTMLInputElement | null;
  if (!input) return;

  const span = document.createElement('span');

  if (p.obscured) {
    span.appendChild(
      createIconButton({
        onClick: () => {
          const isObscured = e.dataset.obscured === 'true';
          e.setAttribute('data-obscured', isObscured ? 'false' : 'true');
        },
        className: 'fa-solid fa-eye',
      }),
    );
  }

  if (p.copyable) {
    span.appendChild(
      createIconButton({
        onClick: () => {
          navigator.clipboard.writeText(input.value);
        },
        className: 'fa-solid fa-paste',
        tooltipText: 'Copy to clipboard',
      }),
    );
  }

  if (span.childNodes.length) {
    const wrapper = e.closest('.editable-wrapper') ?? e;
    const actionSlot = Array.from(wrapper.children).find((child) => child.classList.contains('editable-actions'));

    if (!actionSlot) return;

    actionSlot.replaceChildren(...Array.from(span.childNodes));
  }
};
